import React, { Component } from 'react';
import InspectionTransform from '../../../../../../lib/utils/transforms/inspections';
import { DAMAGES_PICTURES } from '../../../../../../constants/app/files';
import GalleryCar from '../../../../../shared/gallery';
import { MESSAGES_WITHOUT_PICTURES } from '../../../../../../constants/app/vehicle';
import Comments from './comments';
import { INSPECTION_STATE_CODE } from '../../../../../../constants/app/inspection';

const Damages = ({images, inspection = {}, onChangeDamage, saveComment, handleSelect, picturesObserveds = []}) => {
	const galleryImages = images ? InspectionTransform.transformImages(images, DAMAGES_PICTURES, 'damageCode') : [];
	let commentIsDisabled = false;
	if (inspection.damageComment === inspection.damageCommentDB) {
		commentIsDisabled = true;
	} else if (inspection.state.inspectionStatus === INSPECTION_STATE_CODE.SENT) {
			commentIsDisabled = false;
	} else if (inspection.state.inspectionStatus === INSPECTION_STATE_CODE.DERIVE) {
		commentIsDisabled = false;
	}
	else {		
			commentIsDisabled = true;
	}
	return(
		<div className="row row-tab-container">
			<Comments
				visible={!!(images.length)}
				handleChange={onChangeDamage}
				title='Ingresa los daños'
				handleSave={saveComment}
				comments={inspection.damageComment}
				isDisabled={commentIsDisabled} />
			<GalleryCar images={galleryImages} title={MESSAGES_WITHOUT_PICTURES.type_02} message={MESSAGES_WITHOUT_PICTURES.MESSAGE}  handleSelect={handleSelect('damage')} picturesObserveds={picturesObserveds} allImages={images} inspection={inspection}/>
		</div>
	);
}
export default Damages;


// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/damages/index.js